module.exports = __webpack_public_path__ + "static/media/paletprod.3db3c8bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/paletprod.jpg
// module id = 209
// module chunks = 0